const slackImg = 'assets/images/elements/slack.svg';
const webflowImg = 'assets/images/elements/webflow.svg';
const mailchimpImg = 'assets/images/elements/mailchimp.svg';
const redditImg = 'assets/images/elements/reddit.svg';
const blogImg2 = 'assets/images/blog/4by4/02.jpg';
const blogImg1 = 'assets/images/blog/4by4/01.jpg';
const blogImg3 = 'assets/images/blog/4by4/03.jpg';
const blog2Img = 'assets/images/blog/02.jpg';

export const ACCOUNT_VERTICAL_MENU_ITEMS = [
  {
    key: 'account-profile',
    label: 'My Profile',
    url: '/account/profile',
    parentKey: 'pages-account',
    icon: 'bi-person',
  },
  {
    key: 'account-security',
    label: 'Security',
    url: '/account/security',
    parentKey: 'pages-account',
    icon: 'bi-shield-lock'
  },
  {
    key: 'account-notifications',
    label: 'Notifications',
    url: '/account/notifications',
    parentKey: 'pages-account',
    icon: 'bi-bell'
  },
  {
    key: 'account-projects',
    label: 'My Projects',
    url: '/account/projects',
    parentKey: 'pages-account',
    icon: 'bi-briefcase'
  },
  {
    key: 'account-payment-details',
    label: 'Payment Details',
    url: '/account/payment-details',
    parentKey: 'pages-account',
    icon: 'bi-wallet'
  },
  {
    key: 'account-order-history',
    label: 'Order History',
    url: '/account/order-history',
    parentKey: 'pages-account',
    icon: 'bi-basket'
  },
  {
    key: 'account-wishlist',
    label: 'Wishlist',
    url: '/account/wishlist',
    parentKey: 'pages-account',
    icon: 'bi-heart'
  },
  {
    key: 'account-delete-profile',
    label: 'Delete Profile',
    url: '/account/delete-profile',
    parentKey: 'pages-account',
    icon: 'bi-trash'
  },
];

export const APP_MENU_ITEMS = [
  {
    key: 'smart-meters',
    label: 'Smart Meters',
    children: [
      {
        key: 'smart-gas-meter',
        label: 'Smart Gas Meter',
        url: '/smart-gas-meter',
        parentKey: 'smart-meters',
      },
      {
        key: 'smart-water-meters',
        label: 'Untrasonic Smart Water Meter',
        url: '/smart-water-meter',
        parentKey: 'smart-meters',
      },
      {
        key: 'smart-energy-meters',
        label: 'Smart Energy Meter',
        url: '/smart-energy-meter',
        parentKey: 'smart-meters',
      }
    ],
  },
  {
    key: 'safty-devices',
    label: 'Safty Devices',
    children: [
      {
        key: 'sgld',
        label: 'Smart Gas Leak Detector',
        url: '/',
        parentKey: 'safty-devices',
      }
    ],
  },
  {
    key: 'software-solutions',
    label: 'Software Solutions',
    children: [
      {
        key: 'iot-hes-management',
        label: 'IoT / HES Device Management & Analytics',
        url: '/head-end-system',
        parentKey: 'software-solutions',
      },
      {
        key: 'mdm',
        label: 'MDM (Meter Data Management System)',
        url: '/contact/v1',
        parentKey: 'software-solutions',
      }
    ],
  },
  {
    key: 'smart-modules',
    label: 'Smart Modules',
    children: [
      {
        key: 'communication-technologies',
        label: 'Communication Technologies',
        url: '/contact/v1',
        parentKey: 'smart-modules',
      },
      {
        key: 'modules',
        label: 'Modules',
        url: '/contact/v1',
        parentKey: 'smart-modules',
      }
    ],
  },
];
export const MEGA_MENU_ITEMS = {
  usefulLinks: [
    'Market Research',
    'Advertising',
    'Consumer behavior',
    'Digital marketing',
    'Marketing ethics',
    'Social media marketing',
  ],
  company: [
    {
      icon: 'bi-boxes',
      title: 'About us',
      description: 'Learn about our story, our mission statement and roadmap.',
    },
    {
      icon: 'bi-rocket',
      title: 'Career',
      badge: '3 Jobs',
      description: "We're always looking for talented people. Join our team!",
    },
    {
      icon: 'bi-emoji-sunglasses',
      title: 'Customer stories',
      description:
        'Learn how our customer are making big changes to their tech stack',
    },
  ],
  integration: [
    {
      logo: slackImg,
      name: 'Slack',
    },
    {
      logo: webflowImg,
      name: 'Webflow',
    },
    {
      logo: mailchimpImg,
      name: 'Mailchimp',
    },
    {
      logo: redditImg,
      name: 'Reddit',
    },
  ],
  recentBlogs: [
    {
      image: blogImg2,
      title: '10 things you need to know about Mizzle',
      link: '/blog/single/v1',
    },
    {
      image: blogImg1,
      title: 'The Power of Gratitude: Cultivating Joy and Abundance',
      link: '/blog/single/v2',
    },
    {
      image: blogImg3,
      title: 'Effortless Web Development with Mizzle',
      link: '/blog/single/v1',
    },
  ],
};
export const RESOURCES_MENU_ITEMS = {
  usefulLinks: [
    {
      icon: 'bs-file-text',
      name: 'Guides',
    },
    {
      icon: 'bs-chat-left',
      name: 'Supports',
    },
    {
      icon: 'bs-calendar3-week',
      name: 'Community & events',
    },
    {
      icon: 'bs-blockquoter-ight',
      name: 'Blogs',
    },
    {
      icon: 'bs-lock',
      name: 'Security',
    },
    {
      icon: 'bs-star',
      name: 'Tutorials',
    },
    {
      icon: 'bs-question-circle',
      name: 'Help center',
    },
    {
      icon: 'bs-envelope',
      name: 'Developer newsletter',
    },
  ],
  keyFeatures: [
    {
      title: 'Documentation',
      description: 'Using documentation you can easily develop projects',
      icon: 'bi-file-earmark-text',
    },
    {
      title: 'Snippets',
      description: 'Development guides for building projects with Mizzle',
      icon: 'bi-stickies',
    },
    {
      title: 'Changelog',
      description:
        'Recent feature release and announcement. See how changes are made.',
      icon: 'bi-bullseye',
    },
    {
      title: 'Playwright tips',
      description: 'Tips and In-depth guide for headless browser automation',
      icon: 'bi-mask',
    },
  ],
  featureResource: {
    title: 'Featured title here',
    description:
      'Departure defective arranging rapturous did believe him all had supported.',
    image: blog2Img,
  },
};
